import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getPopularSleeves } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";
import { getPopularTags } from "../../api/getComments";

class PopularSleevesContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || [];
    const { sleeves } = results;
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && sleeves.length === 0) {
      return null;
    }
    return render({ sleeves, loading, failure });
  };
}

export default CreateContainer(getPopularSleeves, PopularSleevesContainer);
